import { render, staticRenderFns } from "./ActivityManage.vue?vue&type=template&id=5a1e5084&scoped=true"
import script from "./ActivityManage.vue?vue&type=script&lang=js"
export * from "./ActivityManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e5084",
  null
  
)

export default component.exports